var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.logos)?_c('div',{staticClass:"logo-marquee",style:(_vm.cssVars)},[_c('div',{staticClass:"marquee"},_vm._l((_vm.allLogos),function(logo){return _c('div',{key:logo.id,staticClass:"image-container"},[_c('img',{attrs:{"src":_vm.baseURL + logo.url,"alt":logo.alternativeText}})])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }